import { useCollaboratorsState } from '@components/ArtBoard/Collaboration/hooks'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { useAuth, useProjectAccess } from '@/hooks'
import { useArtBoardDisabled } from '@/hooks/selectors/useArtBoardDisabled'
import { PROJECT_TITLE_PERMISSION } from '@/permissions/project/definitions'

export const useProjectName = () => {
  const [showRenameProject, setShowRenameProject] = useState(false)

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const name = useSelector(migrationProjectSelector.getProjectTitle)

  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  const { authenticated } = useAuth()

  const { hasAccess } = useProjectAccess(PROJECT_TITLE_PERMISSION.CHANGE_TITLE)

  const collaborators = useCollaboratorsState()

  const artboardDisabled = useArtBoardDisabled()

  // the title is saved as a project commit, so it is locked with the artboard
  const access =
    ((hasAccess && !isReadOnly) || (canEdit && authenticated)) &&
    !artboardDisabled

  const handleNameClick = () => {
    if (access) {
      setShowRenameProject(true)
    }
  }

  const handleHideInput = () => {
    setShowRenameProject(false)
  }

  return {
    name,
    access,
    showRenameProject,
    collaborators,
    handleNameClick,
    handleHideInput,
  }
}
